/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pdf_Cv_Review_Comment_Type_LegendInputs */

const en_pdf_cv_review_comment_type_legend = /** @type {(inputs: Pdf_Cv_Review_Comment_Type_LegendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legende der Kommentar-Typen:`)
};

const de_pdf_cv_review_comment_type_legend = /** @type {(inputs: Pdf_Cv_Review_Comment_Type_LegendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legende der Kommentar-Typen:`)
};

/**
* | output |
* | --- |
* | "Legende der Kommentar-Typen:" |
*
* @param {Pdf_Cv_Review_Comment_Type_LegendInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pdf_cv_review_comment_type_legend = /** @type {((inputs?: Pdf_Cv_Review_Comment_Type_LegendInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pdf_Cv_Review_Comment_Type_LegendInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pdf_cv_review_comment_type_legend(inputs)
	return en_pdf_cv_review_comment_type_legend(inputs)
});